// PWA de l'espace volontaire : écoute de l'invite d'installation et service worker limité à /volontaires/.
export default defineNuxtPlugin(() => {
  usePwa().init()

  if (!('serviceWorker' in navigator) || import.meta.dev) {
    return
  }

  // buildId dans l'URL : chaque déploiement change le script, le navigateur installe donc toujours la dernière version.
  const { buildId } = useRuntimeConfig().app
  const hadController = !!navigator.serviceWorker.controller
  let reloading = false

  // Le nouveau service worker (skipWaiting + claim) prend la main : on recharge pour appliquer l'interface à jour.
  if (hadController) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return
      reloading = true
      location.reload()
    })
  }

  const register = () => navigator.serviceWorker
    .register(`/volontaires-sw.js?v=${buildId}`, { scope: '/volontaires/' })
    .then((reg) => {
      // Recherche une mise à jour à chaque retour au premier plan (PWA rouverte, reprise après veille).
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {})
      })
    })
    .catch(() => {})

  if (location.pathname.startsWith('/volontaires')) {
    if (document.readyState === 'complete') {
      register()
    }
    else {
      window.addEventListener('load', register, { once: true })
    }
  }
})
